/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()

export class BookmarkSliderService {
  private showbookmarksSlideSubject = new BehaviorSubject<string>('out');
  public showbookmarksSlide$ = this.showbookmarksSlideSubject.asObservable();

  public show() {
    this.showbookmarksSlideSubject.next('in');
  }

  public hide() {
    this.showbookmarksSlideSubject.next('out');
  }

  public toggle() {
    const current = this.showbookmarksSlideSubject.getValue();
    this.showbookmarksSlideSubject.next(current === 'in' ? 'out' : 'in');
  }
}
